// extracted by mini-css-extract-plugin
module.exports = {"partners":"Partners_partners__1cdUp","container":"Partners_container__3P_aL","partner":"Partners_partner__3QWAe"};